const LIVE_API_BASE = "https://api.skepper.in";
export function getEmagazineApiBase() {
  return LIVE_API_BASE;
}

export function buildEmagazineApiUrl(path = "") {
  const cleanPath = String(path).replace(/^\/+/, "");
  return `${getEmagazineApiBase()}/${cleanPath}`;
}

export function buildEmagazineUploadUrl(filename = "") {
  if (!filename) {
    return "";
  }

  const imagePath = String(filename).trim();
  const legacyUploadMatch = imagePath.match(
    /^https?:\/\/(?:www\.)?(?:skepper\.in|theskepper\.com)\/byb-backend-code\/uploads\/(.+)$/i
  );

  if (legacyUploadMatch) {
    return `${LIVE_API_BASE}/uploads/${legacyUploadMatch[1]}`;
  }


  if (/^https?:\/\//i.test(imagePath) || imagePath.startsWith("/")) {
    return imagePath;
  }

  return `${LIVE_API_BASE}/uploads/${imagePath.replace(/^uploads\//i, "")}`;
}

const CATEGORY_SLUG_TO_NAME = {
  articles: "Articles",
  "expert-talks": "Expert Talks",
  "industry-news": "Industry News",
  podcast: "Podcast",
  strategy: "Strategy",
  "whats-buzzing": "What\u2019s Buzzing",
};

export function slugifyEmagazineCategory(category = "") {
  return String(category || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[’']/g, "")
    .replace(/\u2019/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
}

export function resolveEmagazineCategoryParam(category = "") {
  const decodedCategory = decodeURIComponent(String(category || "").trim());
  const slug = slugifyEmagazineCategory(decodedCategory);

  return CATEGORY_SLUG_TO_NAME[slug] || decodedCategory;
}

export function buildCleanEmagazineCategoryPath(category = "") {
  const slug = slugifyEmagazineCategory(category);
  return slug ? `/e-magazine/${slug}` : "/e-magazine/";
}

export function buildEmagazineCategoryPath(category = "") {
  return buildCleanEmagazineCategoryPath(category);
}

export function buildEmagazineArticlePath(category = "", slug = "") {
  return `${buildEmagazineCategoryPath(category)}/${encodeURIComponent(
    String(slug).trim()
  )}`;
}
